/// <amd-module name="TFS/Admin/Views/ProjectGroups/redux/ProjectGroupsRootProviderProps" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IRootProviderProps } from "VSS/Redux/RootProvider";

export interface IProjectsHubSagaContext {
    pageContext: IVssPageContext;
}

export function getProjectsHubRootProviderProps(pageContext: IVssPageContext): IRootProviderProps<IProjectsHubSagaContext, any> {
    const initialState = {};

    const sagaContext = { pageContext };

    return {
        initialState,
        sagaContext,
        scenarioName: "ProjectsHub",
        modules: []
    };
}
